import { useState, useEffect, useMemo } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faListUl,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import Item from "./item";
import { useNavigate } from "react-router-dom";
import LogOut from "../../Component/LogOut/LogOut";
import imgUser from "../../Image/team-01.png";
import { useSidebar } from "../../Context/SidebarContext";
import { getDriveImageUrl } from "../../util/Driveimage";
import { clearUserSession, getUserSession } from "../../function/AuthStorage";

const menuItems = [
  {
    id: "home",
    icon: "fa-duotone fa-solid fa-chart-pie-simple",
    name: "الرئيسيه",
    link: "/home-page",
    roles: ["admin"],
    adminOnly: true,
  },

  // {
  //   id: "homee",
  //   icon: "fa-duotone fa-solid fa-chart-pie-simple",
  //   name: "الداش",
  //   link: "/home-pagee",
  //   roles: ["admin"],
  //   adminOnly: true,
  // },

  {
    id: "search",
    icon: "fa-light fa-chart-simple",
    name: "بحث الطلبات",
    link: "/search-requests",
    roles: ["all"],
    anyOf: [
      "Construction.View",
      "Emergency.View",
      "Maintenance.View",
      "NewProject.View",
      "PrivateProject.View",
    ],
  },
  {
    id: "private-projects",
    icon: "fa-light fa-building",
    name: "المشاريع الخاصة",
    link: "/all-admin-private-project",
    roles: ["all"],
    permission: "PrivateProject.View",
  },
  {
    id: "add-account",
    icon: "fa-light fa-bag-shopping",
    name: "الحسابات",
    link: "/accounts",
    roles: ["all"],
    permission: "Users.View",
  },

  // {
  //   id: "engineers",
  //   icon: "fa-light fa-user-helmet-safety",
  //   name: "المهندسين",
  //   link: "/engineers",
  //   roles: ["all"],
  //   permission: "Employees.View",
  // },

  {
    id: "branches",
    icon: "fa-solid fa-code-branch",
    name: "الافرع",
    link: "/branches",
    roles: ["all"],
    permission: "Branch.View",
  },
  {
    id: "employees",
    icon: "fa-light fa-briefcase",
    name: "العاملين",
    link: "/employees",
    roles: ["all"],
    permission: "Employees.View",
  },
  {
    id: "permissions",
    icon: "fa-light fa-shield",
    name: "اضافة صلاحيات",
    link: "/add-permission",
    roles: ["all"],
    permission: "Users.ManagePermissions",
  },
  {
    id: "offices",
    icon: "fa-solid fa-building",
    name: "المكاتب",
    link: "/offices",
    roles: ["all"],
    permission: "Office.View",
  },
  {
    id: "districts",
    icon: "fa-light fa-city",
    name: "الاحياء",
    link: "/district",
    roles: ["all"],
    permission: "Neighborhood.View",
  },
  {
    id: "consultants",
    icon: "fa-light fa-user-tie",
    name: "الاستشاريون",
    link: "/consultants",
    roles: ["all"],
    permission: "Consultant.View",
  },
  {
    id: "project-owners",
    icon: "fa-light fa-user",
    name: "ملاك المشاريع",
    link: "/project-owners",
    roles: ["all"],
    permission: "ProjectOwner.View",
  },
  {
    id: "project-parties",
    icon: "fa-light fa-building",
    name: "جهات المشاريع",
    link: "/project-parties",
    roles: ["all"],
    permission: "ProjectParty.View",
  },
  {
    id: "accept-requests",
    icon: "fa-solid fa-check-circle",
    name: "قبول الطلبات",
    link: "/accept-requests",
    roles: ["all"],
    anyOf: [
      "Construction.Approve",
      "Emergency.Approve",
      "Maintenance.Approve",
      "NewProject.Approve",
      "PrivateProject.Approve",
    ],
  },
  {
    id: "delete-requests",
    icon: "fa-solid fa-trash",
    name: "طلبات الحذف",
    link: "/accept-delete",
    roles: ["all"],
    anyOf: [
      "Construction.Delete",
      "Emergency.Delete",
      "Maintenance.Delete",
      "NewProject.Delete",
      "PrivateProject.Delete",
    ],
  },
  {
    id: "custodies",
    icon: "fa-solid fa-box",
    name: "العهد",
    link: "/custodies",
    roles: ["all"],
    permission: "Custody.View",
  },
  {
    id: "notifications",
    icon: "fa-light fa-bell",
    name: "الاشعارات",
    link: "/notification",
    roles: ["all"],
    permission: "Notifications.View",
  },
  {
    id: "vacations",
    icon: "fa-light fa-calendar-check",
    name: "الإجازات",
    link: "/vacations",
    roles: ["all"],
    permission: "LeaveRequest.View",
  },
  {
    id: "check-attendance",
    icon: "fa-light fa-check-circle",
    name: "تسجيل الحضور",
    link: "/check-attendance",
    roles: ["all"],
    permission: "Attendance.View",
  },
  {
    id: "task-type",
    icon: "fa-light fa-briefcase",
    name: "نوع أمر العمل",
    link: "/tasktype",
    roles: ["all"],
    permission: "WorkOrderType.View",
  },
  {
    id: "trash",
    icon: "fa fa-trash",
    name: "سلة المهملات",
    link: "/deleted-projects",
    roles: ["all"],
    anyOf: [
      "Construction.Delete",
      "Emergency.Delete",
      "Maintenance.Delete",
      "NewProject.Delete",
      "PrivateProject.Delete",
    ],
  },

  // الملف الشخصي
  {
    id: "profile",
    icon: "fa-light fa-id-card",
    name: "الملف الشخصي",
    link: "/profile",
    roles: ["all"],
  },
];

function getUserPermissions() {
  const user = getUserSession();
  return user?.permissions || [];
}

// ─── Helper: يتحقق هل المستخدم عنده الـ permission ──────────────────────
function checkPermission(item, userPerms, isAdmin, userRole) {
  // adminOnly → admin فقط
  if (item.adminOnly) return isAdmin;

  // admin يشوف كل حاجة
  if (isAdmin) return true;

  // عنصر من غير أي شرط صلاحية → يظهر للجميع
  if (!item.permission && !item.anyOf) return true;

  // باقي الـ roles → تحقق من الـ permissions
  if (item.permission) return userPerms.includes(item.permission);

  if (item.anyOf?.length > 0) {
    return item.anyOf.some((p) => userPerms.includes(p));
  }

  return false;
}

function Sidebar() {
  const navigate = useNavigate();
  const { open, toggle } = useSidebar();

  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

  // التحكم في القوائم المنسدلة
  const [openGroups, setOpenGroups] = useState({
    requests: false,
    projects: false,
    management: false,
    employees: false,
    system: false,
  });

  const cookieValue = useMemo(() => {
    return getUserSession() || {};
  }, []);

  const userRole = cookieValue.userType || "";
  const isAdmin = userRole === "admin";

  const userPerms = useMemo(() => getUserPermissions(), []);

  const userImageSrc = useMemo(
    () => getDriveImageUrl(cookieValue.userImage) || imgUser,
    [cookieValue.userImage]
  );

  const handleLogoutClick = () => setLogoutDialogOpen(true);

  const functionLogout = () => {
    clearUserSession();
    localStorage.clear();
    navigate("/");
  };

  const filteredMenuItems = useMemo(() => {
    return menuItems.filter((item) => {
      const roleOk =
        item.roles.includes("all") || item.roles.includes(userRole);

      if (!roleOk) return false;

      return checkPermission(item, userPerms, isAdmin, userRole);
    });
  }, [userRole, userPerms, isAdmin]);

  // ─────────────────────────────────────────────
  // تنظيم العناصر داخل القوائم
  // ─────────────────────────────────────────────

  const menuGroups = useMemo(() => {
    const getItems = (ids) =>
      filteredMenuItems.filter((item) => ids.includes(item.id));

    return {
      requests: getItems([
        "search",
        "accept-requests",
        "delete-requests",
        "trash",
      ]),

      projects: getItems([
        "private-projects",
        "consultants",
        "project-owners",
        "project-parties",
      ]),

      management: getItems([
        "add-account",
        "branches",
        "offices",
        "districts",
        "permissions",
      ]),

      employees: getItems([
        "employees",
        "vacations",
        "check-attendance",
        "custodies",
      ]),

      system: getItems([
        "notifications",
        "task-type",
      ]),
    };
  }, [filteredMenuItems]);

  const homeItem = filteredMenuItems.find((item) => item.id === "home");

  const profileItem = filteredMenuItems.find(
    (item) => item.id === "profile"
  );

  const toggleGroup = (group) => {
    setOpenGroups((prev) => ({
      ...prev,
      [group]: !prev[group],
    }));
  };

  const sideContainerVariants = {
    true: { width: "13rem" },
    false: { width: "5rem", transition: { delay: 0.6 } },
  };

  const sidebarVariants = {
    true: { width: "200px" },
    false: { width: "5rem", transition: { delay: 0.4 } },
  };

  // ─────────────────────────────────────────────
  // شكل عنوان الـ Dropdown
  // ─────────────────────────────────────────────

  const GroupHeader = ({ title, group, icon }) => {
    const isGroupOpen = openGroups[group];

    return (
      <motion.button
        type="button"
        onClick={() => toggleGroup(group)}
        whileHover={{
          scale: open ? 1.01 : 1,
        }}
        className={`
          w-full
          flex
          items-center
          justify-between
          gap-2
          mb-1
          px-3
          py-2.5
          rounded-xl
          border
          border-white/10
          bg-white/[0.06]
          hover:bg-white/[0.12]
          transition-all
          duration-200
          text-white
          cursor-pointer
          shrink-0
          ${!open ? "justify-center px-1" : ""}
        `}
      >
        <div
          className={`
            flex items-center gap-2.5 min-w-0
            ${!open ? "justify-center w-full" : ""}
          `}
        >
          <FontAwesomeIcon
            icon={icon}
            className="text-sm shrink-0 opacity-90"
          />

          {open && (
            <span className="text-sm font-semibold whitespace-nowrap">
              {title}
            </span>
          )}
        </div>

        {open && (
          <motion.div
            animate={{
              rotate: isGroupOpen ? 180 : 0,
            }}
            transition={{ duration: 0.2 }}
            className="text-xs opacity-70"
          >
            <FontAwesomeIcon icon={faChevronDown} />
          </motion.div>
        )}
      </motion.button>
    );
  };

  // ─────────────────────────────────────────────
  // محتوى الـ Dropdown
  // ─────────────────────────────────────────────

  const GroupItems = ({ group }) => {
    const items = menuGroups[group];

    if (!items?.length) return null;

    return (
      <AnimatePresence initial={false}>
        {openGroups[group] && open && (
          <motion.div
            initial={{
              height: 0,
              opacity: 0,
            }}
            animate={{
              height: "auto",
              opacity: 1,
            }}
            exit={{
              height: 0,
              opacity: 0,
            }}
            transition={{
              duration: 0.25,
              ease: "easeInOut",
            }}
            className="overflow-hidden"
          >
            <div className="mr-2 pr-2 border-r border-white/10 mb-2">
              {items.map((item) => (
                <motion.div
                  key={item.id}
                  initial={{ opacity: 0, x: 8 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.18 }}
                >
                  <Item
                    id={item.id}
                    icon={item.icon}
                    name={item.name}
                    link={item.link}
                  />
                </motion.div>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    );
  };

  return (
    <>
      <motion.div
        data-open={open}
        variants={sideContainerVariants}
        initial={`${open}`}
        animate={`${open}`}
        className="fixed top-0 right-0 h-screen z-[1001]"
      >
        <motion.div
          initial={`${open}`}
          animate={`${open}`}
          variants={sidebarVariants}
          className="
            flex flex-col
            w-full
            h-full
            box-border
            p-4
            m-0
            bg-mainColor
            text-white
            backdrop-blur-md
            border
            border-white/20
            [direction:rtl]
            transition-[width]
            duration-300
            ease-in-out
            overflow-hidden
          "
        >
          {/* زر فتح وقفل الـ Sidebar */}
          <motion.div
            whileHover={{
              scale: 1.2,
              rotate: 180,
              backgroundColor: "rgba(255, 255, 255, 0.3)",
              backdropFilter: "blur(3.5px)",
              border: "1px solid rgba(255, 255, 255, 0.18)",
              transition: { delay: 0.2, duration: 0.4 },
            }}
            onClick={toggle}
            className="
              flex
              self-end
              cursor-pointer
              mb-5
              text-xl
              rounded-md
              shrink-0
            "
          >
            <FontAwesomeIcon icon={faListUl} />
          </motion.div>

          {/* محتوى الـ Sidebar */}
          <div className="flex flex-col w-full flex-1 overflow-y-auto overflow-x-hidden min-h-0">

            {/* الرئيسية - تفضل لوحدها */}
            {homeItem && (
              <div className="mb-2">
                <Item
                  id={homeItem.id}
                  icon={homeItem.icon}
                  name={homeItem.name}
                  link={homeItem.link}
                />
              </div>
            )}

            {/* ───────── الطلبات ───────── */}
            {menuGroups.requests.length > 0 && (
              <div className="mb-1">
                <GroupHeader
                  title="الطلبات"
                  group="requests"
                  icon="fa-light fa-file-lines"
                />
                <GroupItems group="requests" />
              </div>
            )}

            {/* ───────── المشاريع ───────── */}
            {menuGroups.projects.length > 0 && (
              <div className="mb-1">
                <GroupHeader
                  title="المشاريع"
                  group="projects"
                  icon="fa-light fa-building"
                />
                <GroupItems group="projects" />
              </div>
            )}

            {/* ───────── الإدارة ───────── */}
            {menuGroups.management.length > 0 && (
              <div className="mb-1">
                <GroupHeader
                  title="الإدارة"
                  group="management"
                  icon="fa-light fa-gear"
                />
                <GroupItems group="management" />
              </div>
            )}

            {/* ───────── العاملين ───────── */}
            {menuGroups.employees.length > 0 && (
              <div className="mb-1">
                <GroupHeader
                  title="العاملين والموارد"
                  group="employees"
                  icon="fa-light fa-users"
                />
                <GroupItems group="employees" />
              </div>
            )}

            {/* ───────── النظام ───────── */}
            {menuGroups.system.length > 0 && (
              <div className="mb-1">
                <GroupHeader
                  title="النظام"
                  group="system"
                  icon="fa-light fa-sliders"
                />
                <GroupItems group="system" />
              </div>
            )}

            {/* ───────── مدير المكتب ───────── */}
            {userRole === "officeManager" && (
              <div className="mb-1">
                <Item
                  id="office-manager"
                  icon="fa-light fa-user-tie"
                  name="مدير المكتب"
                  link="/manager-profile"
                />
              </div>
            )}

            {/* ───────── الملف الشخصي ───────── */}
            {profileItem && (
              <div className="mt-1">
                <Item
                  id={profileItem.id}
                  icon={profileItem.icon}
                  name={profileItem.name}
                  link={profileItem.link}
                />
              </div>
            )}
          </div>

          {/* بيانات المستخدم */}
          {cookieValue && (
            <motion.div
              className={`
                bg-white
                text-mainColor
                rounded-xl
                transition-all
                duration-300
                w-full
                shrink-0
                mt-2
                flex
                items-center
                ${
                  open
                    ? "p-3 opacity-100"
                    : "p-1.5 opacity-0 pointer-events-none h-0 overflow-hidden"
                }
              `}
            >
              <img
                src={userImageSrc}
                alt="User"
                onError={(e) => {
                  e.currentTarget.src = imgUser;
                }}
                className="
                  w-10
                  h-10
                  rounded-full
                  mr-2.5
                  shrink-0
                  object-cover
                "
              />

              <div className="text-right whitespace-normal break-words min-w-0 flex-1">
                <h4 className="m-0 text-sm whitespace-normal break-words">
                  {cookieValue.userName}
                </h4>

                <p className="m-0 text-xs text-gray-500">
                  {cookieValue.email}
                </p>
              </div>
            </motion.div>
          )}

          {/* تسجيل الخروج */}
          {cookieValue && (
            <button
              onClick={handleLogoutClick}
              className={`
                bg-white/10
                text-white
                border
                border-white/20
                rounded-md
                cursor-pointer
                transition-colors
                duration-300
                hover:bg-secondaryColor
                shrink-0
                w-full
                mt-2
                ${
                  open
                    ? "text-sm px-4 py-2"
                    : "text-[8px] px-1 py-2"
                }
              `}
            >
              {open ? "تسجيل الخروج" : "خروج"}
            </button>
          )}
        </motion.div>
      </motion.div>

      <LogOut
        open={logoutDialogOpen}
        onClose={() => setLogoutDialogOpen(false)}
        onConfirm={functionLogout}
      />
    </>
  );
}

export default Sidebar;